module.exports = __webpack_public_path__ + "static/media/mikser.5d93acdd.png";